export const getDisplayName = (Component) => {
    return (
        Component.displayName ||
        Component.name ||
        (typeof Component === 'string' && Component.length > 0
            ? Component
            : 'Unknown')
    );
};
